import { sessionHelper } from "./SessionHelper";

export const getResponseFromApi = async (url: string, requestInit: RequestInit = {}) => {    
    const token = sessionHelper.accessToken;

    requestInit.headers = {
        "Authorization": `Bearer ${token}`,
        ...requestInit.headers
    };

    const resp = await fetch(url, requestInit);

    return resp;
};
